import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Card,
  CardContent,
  Button,
  Box
} from '@mui/material';

// 유니크 키 생성 함수
const generateUniqueKey = () => {
  return `key-${Math.random().toString(36).substring(2, 12)}-${Date.now()}`;
};

const TestKeyPage = () => {
  const [keyValue, setKeyValue] = useState(null);
  const [ip, setIp] = useState('불러오는 중...');
  const [browserInfo, setBrowserInfo] = useState('불러오는 중...');
  const [deviceInfo, setDeviceInfo] = useState('불러오는 중...');

  useEffect(() => {
    // 로컬 스토리지 키 확인/생성
    const existingKey = localStorage.getItem('FLAGSHOP_APP_TEST_KEY');
    if (existingKey) {
      setKeyValue(existingKey);
    } else {
      const newKey = generateUniqueKey();
      localStorage.setItem('FLAGSHOP_APP_TEST_KEY', newKey);
      setKeyValue(newKey);
    }

    // 브라우저 정보
    const ua = navigator.userAgent;
    const platform = navigator.platform || '알 수 없음';
    setBrowserInfo(ua);
    setDeviceInfo(platform);

    // IP 가져오기
    fetch('https://api.ipify.org?format=json')
      .then((res) => res.json())
      .then((data) => setIp(data.ip))
      .catch(() => setIp('불러오기 실패'));
  }, []);

  const regenerateKey = () => {
    const newKey = generateUniqueKey();
    localStorage.setItem('FLAGSHOP_APP_TEST_KEY', newKey);
    setKeyValue(newKey);
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        width: '100%',
        maxWidth: '500px !important',
        mt: 5,
        display: 'flex',
        justifyContent: 'center'
      }}
    >
      <Card sx={{ width: '100%', p: 2 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            🔑 테스트 키값
          </Typography>
          <Box sx={{ mt: 2 }}>
            <Typography variant="body1">
              <strong>키:</strong> FLAGSHOP_APP_TEST_KEY
            </Typography>
            <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
              <strong>키 값:</strong> {keyValue || '생성 중...'}
            </Typography>
          </Box>

          <Box sx={{ mt: 3 }}>
            <Typography variant="body1">
              <strong>📡 IP 주소:</strong> {ip}
            </Typography>
            <Typography variant="body1">
              <strong>💻 디바이스:</strong> {deviceInfo}
            </Typography>
            <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
              <strong>🌐 브라우저:</strong> {browserInfo}
            </Typography>
          </Box>

          <Box sx={{ mt: 3, display: 'none', justifyContent: 'flex-end' }}>
            <Button variant="contained" color="primary" onClick={regenerateKey}>
              새 키 생성
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
};

export default TestKeyPage;
